export const hashtagCategories = [
  {name: '言語', key: 'programmingLanguage'},
  {name: 'ライブラリ・フレームワーク', key: 'libraryFramework'},
  {name: 'データベース', key: 'database'},
  {name: 'その他', key: undefined},
] as const;

export type HashtagCategoryType = (typeof hashtagCategories)[number];

export const ReferencesForTheme = [
  {
    themeId: 1,
    references: [
      {
        title: 'ソフトバンク 総合職（エンジニアコース） 25卒',
        url: '/passed_es/10068',
      },
      {
        title: '楽天グループ エンジニア職 25卒',
        url: '/passed_es/9626',
      },
    ],
  },
  {
    themeId: 2,
    references: [
      {
        title: 'ソフトバンク 総合職（エンジニアコース） 25卒',
        url: '/passed_es/10068',
      },
      {
        title: '楽天グループ エンジニア職 25卒',
        url: '/passed_es/9626',
      },
    ],
  },
  {
    themeId: 3,
    references: [
      {
        title: 'AmazonWebService（AWS） Cloud Support Engineer 24卒',
        url: '/passed_es/8032',
      },
      {
        title: 'KDDI ITエンジニアコース 25卒',
        url: '/passed_es/9490',
      },
      {
        title: 'ソニーグループ 技術系 23卒',
        url: '/passed_es/6504',
      },
    ],
  },
  {
    themeId: 4,
    references: [
      {
        title: 'BIPROGY システムエンジニア 25卒 ',
        url: '/passed_es/9720',
      },
      {
        title: 'kubell ソフトウェアエンジニア 24卒',
        url: '/passed_es/8063',
      },
    ],
  },
] as const;
